var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lunch-section-menu-explanation"},[_c('p',[_vm._v(" Eine Vorspeise, ein Hauptgang, Dessert ")]),_c('p',[_c('BasePrice',{attrs:{"price":_vm.price}}),_vm._v(" [an Werktagen] ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }